import React, { useEffect, useState } from "react";
import styled from "styled-components/macro";
import { NavLink, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { spacing } from "@material-ui/system";
import Button from "@material-ui/core/Button";
import Timer from "react-timer-wrapper";
import SaveIcon from "@material-ui/icons/Save";
import EditIcon from "@material-ui/icons/Edit";
import Timecode from "react-timecode";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import SendIcon from "@material-ui/icons/Send";
import swal from "sweetalert2";
import axios from "axios";
import {
  NotifyError,
  NotifySuccess,
} from "../../services/notification.service";
import { GetConfig } from "../../../utils/ConfigHeader";
import {
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  CardContent as MuiCardContent,
  Divider as MuiDivider,
  Paper as MuiPaper,
  Typography,
  Icon,
  Grid,
  CircularProgress,
  TextField,
  FormHelperText,
} from "@material-ui/core";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";

const Card = styled(MuiCard)(spacing);

const CardContent = styled(MuiCardContent)(spacing);

const Divider = styled(MuiDivider)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

function Header() {
  const [MailID, setMailID] = useState("");
  const [EMServer, setEMServer] = useState("");
  const [EMPort, setEMPort] = useState();
  const [SenderName, setSenderName] = useState("");
  const [SenderEmail, setSenderEmail] = useState("");
  const [EMPass, setEMPass] = useState("");
  const [data, setData] = useState([]);
  const history = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isEdited, setIsEdited] = useState(false);
  const [isButtonActive, setButtonActive] = useState(true);
  const [TestToEmail, setTestToEmail] = useState("");
  const [testLoading, setTestLoading] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoading(true);
    try {
      const res = await axios
        .get(`${process.env.REACT_APP_DOMAIN_API}/SetupMail`, GetConfig())
        .then(function (response) {
          // handle success
          console.log("ini seberapa banyak datanya", response.data?.length);
          console.log("ini datanya", response.data);
          if (response.status == 200) {
            const resdata = response.data;
            const lastIndex = resdata?.length - 1;
            setMailID(resdata[lastIndex]?.MailID);
            setEMServer(resdata[lastIndex]?.EMServer);
            setEMPort(resdata[lastIndex]?.EMPort);
            setSenderName(resdata[lastIndex]?.SenderName);
            setSenderEmail(resdata[lastIndex]?.SenderEmail);
            setEMPass(resdata[lastIndex]?.Password);
            setData(resdata);
          }
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        });
      setLoading(false);
    } catch (error) {
      console.log(error.message);
      setLoading(false);
    }
  };

  const notifyConfirm = async (id) => {
    swal
      .fire({
        title: "Apakah Anda Yakin Menyimpan Konfigurasi ini?",
        // text: "Anda tidak akan bisa mengembalikan ini!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3062e3",
        cancelButtonColor: "#d33",
        confirmButtonText: "Simpan",
      })
      .then((result) => {
        if (!result.value) return;
        if (!!MailID) {
          HandleUpdate();
        } else {
          HandleCreate();
        }
      });
  };

  const HandleUpdate = async () => {
    setLoading(true);
    try {
      const payload = {
        mailID: MailID,
        emServer: EMServer,
        emPort: EMPort,
        senderName: SenderName,
        senderEmail: SenderEmail,
        password: EMPass,
      };
      await axios
        .post(
          `${process.env.REACT_APP_DOMAIN_API}/SetupMail/UpdateMail`,
          payload,
          GetConfig()
        )
        .then(function (response) {
          // handle success
          console.log(response);
          if (response.status == 200 || response.status == 201) {
            setIsEdited(false);
            NotifySuccess("success", "Data Telah DiUbah");
            setTimeout(() => {
              window.location.href = `/konfigurasi/set-server-email`;
            }, 1200);
          }
        })
        .catch(function (error) {
          // handle error
          NotifyError("There was an error!", error);
          console.log(error);
        });
      setLoading(false);
    } catch (error) {
      console.log(error.message);
      setLoading(false);
    }
  };
  const HandleCreate = async () => {
    setLoading(true);
    try {
      const payload = {
        emServer: EMServer,
        emPort: EMPort,
        senderName: SenderName,
        senderEmail: SenderEmail,
        password: EMPass,
      };
      await axios
        .post(
          `${process.env.REACT_APP_DOMAIN_API}/SetupMail/CreateMail`,
          payload,
          GetConfig()
        )
        .then(function (response) {
          // handle success
          console.log(response);
          if (response.status == 200 || response.status == 201) {
            setIsEdited(false);
            NotifySuccess("success", "Data Telah Ditambah");
            setTimeout(() => {
              window.location.href = `/konfigurasi/set-server-email`;
            }, 1200);
          }
        })
        .catch(function (error) {
          // handle error
          NotifyError("There was an error!", error);
          console.log(error);
        });
      setLoading(false);
    } catch (error) {
      console.log(error.message);
      setLoading(false);
    }
  };

  const HandleTestEmail = async () => {
    setTestLoading(true);
    try {
      const payload = {
        emServer: EMServer,
        emPort: EMPort,
        senderName: SenderName,
        senderEmail: SenderEmail,
        password: EMPass,
        toEmail: TestToEmail,
      };
      await axios
        .post(
          `${process.env.REACT_APP_DOMAIN_API}/SetupMail/TestMail`,
          payload,
          GetConfig()
        )
        .then(function (response) {
          if (response.status == 200) {
            swal.fire({
              icon: "success",
              title: "Test Email Berhasil",
              text: response.data,
            });
          }
        })
        .catch(function (error) {
          swal.fire({
            icon: "error",
            title: "Test Email Gagal",
            html: error.response?.data,
            customClass: "swal-height",
          });
          console.log(error);
        });
    } catch (error) {
      console.log(error.message);
    }
    setTestLoading(false);
  };

  return (
    <Card mb={6}>
      {/* <CardContent pb={1}>
        <Typography variant="h6" gutterBottom>
          Header
        </Typography>
        <Typography variant="body2" gutterBottom></Typography>
      </CardContent> */}
      {loading ? (
        <Grid container justifyContent="center" spacing={1} md={12} xs={12}>
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <CircularProgress disableShrink style={{ textAlign: "center" }} />
          </Grid>
          <Grid item xs={12} justifyContent="center" alignItems="center">
            <h1 style={{ textAlign: "center" }}>Loading</h1>
          </Grid>
        </Grid>
      ) : (
        <Paper>
          <div style={{ height: 400, width: "100%" }}>
            <Grid container spacing={6} md={8} sx={{ margin: "10px" }}>
              <Grid item md={6} xs={6}>
                <Typography variant="h6" gutterBottom>
                  Server
                </Typography>
                <TextField
                  name="EMServer"
                  // label="Server"
                  value={EMServer}
                  type={"text"}
                  required
                  fullWidth
                  variant="outlined"
                  my={2}
                  disabled={isEdited === false}
                  onChange={(e) => setEMServer(e.target.value)}
                />
                {EMServer === "" && (
                  <FormHelperText style={{ color: "red" }}>
                    Required
                  </FormHelperText>
                )}
              </Grid>
              <Grid item md={6} xs={6}>
                <Typography variant="h6" gutterBottom>
                  Sender Name
                </Typography>
                <TextField
                  name="SenderName"
                  // label="Sender Name"
                  value={SenderName}
                  type="text"
                  required
                  fullWidth
                  variant="outlined"
                  my={2}
                  disabled={isEdited === false}
                  onChange={(e) => setSenderName(e.target.value)}
                />
                {SenderName === "" && (
                  <FormHelperText style={{ color: "red" }}>
                    Required
                  </FormHelperText>
                )}
              </Grid>
              <Grid item md={6} xs={6}>
                <Typography variant="h6" gutterBottom>
                  Port
                </Typography>
                <TextField
                  name="EMPort"
                  // label="Port"
                  value={EMPort}
                  type="text"
                  required
                  fullWidth
                  variant="outlined"
                  my={2}
                  disabled={isEdited === false}
                  onChange={(e) => setEMPort(e.target.value)}
                />
                {EMPort === "" && (
                  <FormHelperText style={{ color: "red" }}>
                    Required
                  </FormHelperText>
                )}
              </Grid>
              <Grid item md={6} xs={6}>
                <Typography variant="h6" gutterBottom>
                  Sender Email
                </Typography>
                <TextField
                  name="SenderEmail"
                  // label="Sender Email"
                  value={SenderEmail}
                  type="email"
                  required
                  fullWidth
                  variant="outlined"
                  my={2}
                  disabled={isEdited === false}
                  onChange={(e) => setSenderEmail(e.target.value)}
                />
                {SenderEmail === "" && (
                  <FormHelperText style={{ color: "red" }}>
                    Required
                  </FormHelperText>
                )}
              </Grid>
              <Grid item md={6} xs={6} sx={{ marginLeft: "auto" }}>
                <Typography variant="h6" gutterBottom>
                  Password
                </Typography>
                <TextField
                  name="Password"
                  // label="Password"
                  value={EMPass}
                  type="password"
                  fullWidth
                  variant="outlined"
                  my={2}
                  disabled={isEdited === false}
                  onChange={(e) => setEMPass(e.target.value)}
                />
                {EMPass === "" && (
                  <FormHelperText style={{ color: "red" }}>
                    Required
                  </FormHelperText>
                )}
                {EMPass?.length < 8 && (
                  <FormHelperText style={{ color: "red" }}>
                    Min. 8 Character Password
                  </FormHelperText>
                )}
              </Grid>
              <Grid item md={6} xs={6}>
                <Typography variant="h6" gutterBottom>
                  Email Tujuan Test
                </Typography>
                <TextField
                  name="TestToEmail"
                  placeholder="Kosongkan untuk kirim ke Sender Email sendiri"
                  value={TestToEmail}
                  type="email"
                  fullWidth
                  variant="outlined"
                  my={2}
                  onChange={(e) => setTestToEmail(e.target.value)}
                />
              </Grid>
              <Grid item md={12} xs={12}>
                <Button
                  style={{ marginRight: "16px" }}
                  variant="contained"
                  color="primary"
                  size="medium"
                  disabled={
                    EMPass == null || EMPass === "" || EMPass?.length < 8
                      ? isButtonActive
                      : false
                  }
                  startIcon={<SaveIcon />}
                  // disabled={
                  //   // (EMServer === "" &&
                  //   //   EMPort === "" &&
                  //   //   SenderName === "" &&
                  //   //   SenderEmail === "" &&
                  //   //   EMPass === "") ||
                  //   isEdited === true
                  // }
                  onClick={notifyConfirm}
                >
                  Save
                </Button>
                <Button
                  style={{ marginRight: "16px" }}
                  variant="contained"
                  color="primary"
                  size="medium"
                  startIcon={<EditIcon />}
                  disabled={isEdited}
                  onClick={() => {
                    setIsEdited(true);
                  }}
                >
                  Edit
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  size="medium"
                  startIcon={<SendIcon />}
                  disabled={
                    testLoading ||
                    !EMServer ||
                    !EMPort ||
                    !SenderEmail ||
                    !EMPass
                  }
                  onClick={HandleTestEmail}
                >
                  {testLoading ? "Mengirim..." : "Test Email"}
                </Button>
              </Grid>
            </Grid>
          </div>
        </Paper>
      )}
    </Card>
  );
}

function SetServerEmail() {
  return (
    <React.Fragment>
      <Helmet title="Set Server Email" />
      <Typography variant="h3" gutterBottom display="inline">
        Setup Server Email
      </Typography>

      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Link component={NavLink} to="/">
          Dashboard
        </Link>
        <Link>Konfigurasi</Link>
        <Typography>Setup Server Email</Typography>
      </Breadcrumbs>

      <Divider my={6} />

      <Header />
    </React.Fragment>
  );
}

export default SetServerEmail;
